<template>
  <div class="container justify-content-center">
    <div class="sticky">
      <h1 class="text-center">БОНУСЫ ПРИЕМЩИКОВ</h1>

      <div class="mb-1 mt-1 row">
        <div class="col-sm-9 label-class">
          <v-select :options="users" label="label" v-model="currentReceiver">
            <template #option="user">
              <span
                >{{ user.receiver.fullname }}: {{ user.receiver.address }}</span
              >
            </template>
            <template #selected-option="user">
              <span>{{ user.receiver.fullname }}</span>
            </template>
          </v-select>
        </div>
      </div>
    </div>

    <div class="main-content">
      <div
        v-for="user in usersFilter"
        :key="user._id"
        class="container pb-2 pt-1"
      >
        <div class="card lh-1">
          <div class="card-body">
            <div class="row row-cols-2">
              <div class="col">
                <span class="fs-5">{{ user.receiver.fullname }}</span>
              </div>
              <div class="col">
                <span class="fs-5">{{ user.receiver.address }}</span>
              </div>
            </div>
            <div class="row row-cols-4 pt-3 px-2 text-center">
              <input
                class="form-control p-1 fs-4 text-center"
                v-model="user.bonus"
                type="number"
                required
                disabled
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { ref, computed, onMounted, inject } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
//import * as bootstrap from 'bootstrap'
//import { Modal } from 'bootstrap'
// import useCardsMixin from "@/components/cardsMixin.js";
import useCommonMixin from "@/components/commonMixin.js";
import "vue-select/dist/vue-select.css";

export default {
  name: "BonusReceiver",
  components: {},

  setup(props) {
    useCommonMixin();
    const { isAdmin } = useCommonMixin();
    // const { showContentDeliverer } = useCommonMixin();
    const store = useStore();
    const router = useRouter();
    const warningBus = inject("warningBus"); // Inject `emitter`
    const users = ref([]);
    const roles = ref([]);
    const currentReceiver = ref();

    const init = async () => {
      let responseUsers = await store.dispatch("FETCHreceiverBonus");
      users.value = responseUsers.status ? responseUsers.data : [];
      users.value.forEach((user) => {
        user.label = `${user.receiver.fullname} ${user.receiver.address}`;
      });

      // let responseRoles = await store.dispatch("FETCHroles");
      // roles.value = responseRoles.status
      //   ? responseRoles.data.filter((role) => role.type != "deliverer")
      //   : [];
      // await store.dispatch("FETCHberry");
    };

    const usersFilter = computed(() => {
      let result = users.value
      if (currentReceiver.value) {
        result = users.value.filter((user) => user._id == currentReceiver.value._id);
      }
      return result;
    });

    const receiverLabel = (user) => {
      return `${user.receiver.fullname}`;
    };

    onMounted(init);

    return {
      usersFilter,
      users,
      currentReceiver,
      receiverLabel,
      isAdmin,
    };
  },
};
</script>

<style>
</style>

